<div class="container">
    <div class="row">
        <div class="col-md-6 m-t-40 m-b-10">
            <h2>{{ 'login.create.title' | translate }}</h2>
            <p>{{ 'login.create.description' | translate }}</p>
        </div>
        <div class="col-md-6 m-t-40 m-b-10">
            <h2>Register</h2>
            <form [formGroup]="registerForm" (ngSubmit)="register()">
                <div class="form-group">
                    <label for="firstname">First Name</label>
                    <input type="text" class="form-control" formControlName="firstname"
                           [ngClass]="{ 'is-invalid': submitted && f.firstname.errors }" />
                    <div *ngIf="submitted && f.firstname.errors" class="invalid-feedback">
                        <div *ngIf="f.firstname.errors.required">First Name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="lastname">Last Name</label>
                    <input type="text" class="form-control" formControlName="lastname"
                           [ngClass]="{ 'is-invalid': submitted && f.lastname.errors }" />
                    <div *ngIf="submitted && f.lastname.errors" class="invalid-feedback">
                        <div *ngIf="f.lastname.errors.required">Last Name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" class="form-control" formControlName="email"
                           [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                        <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" class="form-control" formControlName="password"
                           [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                        <div *ngIf="f.password.errors.strongPassword">
                            Password does not meet complexity requirements
                        </div>
                    </div>
                    <!-- Password strength indicator -->
                    <app-password-strength [password]="f.password.value" [showRequirements]="true"></app-password-strength>
                </div>
                <div class="form-group">
                    <button [disabled]="loading" class="btn btn-primary">
                        <span *ngIf="!loading">Register</span>
                        <span *ngIf="loading">
                            <i class="fa fa-spinner fa-spin"></i> Registering...
                        </span>
                    </button>
                    <a [routerLink]="['/login']" class="btn btn-link">Cancel</a>
                </div>
                <div *ngIf="error" class="alert alert-danger mt-3">
                    {{ error }}
                </div>
            </form>
        </div>
    </div>
</div>